import { TableDataProperties } from "../../../shared/uiComponents/Table/tableProperties";
import {
  SessionTypeProperties,
  UserBriefInfoProperties,
} from "./calendarProperties";
import { InsuranceAuthorizationTypeProperties } from "./insuranceAuthorizationProperties";
import { LocationTypes } from "./soapNoteProperties";

export interface GetReportProperties {
  startDate: string;
  endDate: string;
  userId: string;
  clientId?: string;
  onlyNew: boolean;
  page: string;
  pageSize: string;
  orderBy: string;
  direction: string;
  searchString: string;
  createdById?: string;
  onlySubmitted?: boolean;
  includeAdditionalData?: boolean;
  credentialed?: boolean;
}

export interface GetBillingProperties extends GetReportProperties {
  clientIds: Array<string>;
  mbhBillingStatus?: string;
}

export interface GetTotalBillingProperties {
  startDate: string;
  endDate: string;
  userId?: string;
  clientIds: Array<string>;
}

interface BillingClientProperties {
  id: string;
  firstName: string;
  lastName: string;
  fullName: string;
  email: string;
  dateOfBirthday: string;
  gender: string;
}

interface AuthorizedUserInfoProperties extends UserBriefInfoProperties {
  authorizationType: InsuranceAuthorizationTypeProperties | null;
}

export interface ModifiedSessionProperties {
  originalDate: string;
  originalStartTime: string;
  originalEndTime: string;
  dateModifiedAt: string;
  dateModifiedBy: {
    id: string;
    fullName: string;
    role: string;
    authorizationType: InsuranceAuthorizationTypeProperties;
  };
}

export enum MBHBillingStatus {
  "Not Billed",
  "Approved",
}

export interface BillingProperties {
  authorizedBCBA: null | AuthorizedUserInfoProperties;
  billedBy: null | AuthorizedUserInfoProperties;
  mainTherapist: null | AuthorizedUserInfoProperties;
  client: BillingClientProperties;
  location: LocationTypes | null;
  reportExportedAt: string | null;
  reportExportedBy: AuthorizedUserInfoProperties | null;
  reportId: string;
  reportSubmittedAt: string;
  sessionDate: string;
  sessionEndTime: string;
  sessionId: string;
  sessionStartTime: string;
  sessionType: SessionTypeProperties;
  user: AuthorizedUserInfoProperties;
  sessionDateModifiedDetails: ModifiedSessionProperties | null;
  mbhBillingStatus: MBHBillingStatus | null;
}

export interface BillingSessionsProperties extends TableDataProperties {
  query: Array<BillingProperties> | null;
}

export interface MBHLogsProperties {
  id: string;
  createdAt: string;
  syncedSessionCount: number;
  syncStatus: boolean;
}
